import { toSnakeCase } from '../packages/utils/casing'
import ApiBase from './Api'

class TestDateApi extends ApiBase {
    async adminGetAllTestDates() {
        return this._getRequest('/admin/test-dates')
    }

    async adminUpdateTestDate(testDate) {
        return this._postRequest('/admin/test-dates', toSnakeCase(testDate))
    }
}

export default TestDateApi
